import LinearProgress, {
  type LinearProgressProps,
} from '@material-ui/core/LinearProgress'

import { ProgressStyled } from './styles/ProgressStyled'

export interface IProgressProps extends Omit<LinearProgressProps, 'color'> {
  color?: string
  striped?: boolean
  label?: string
}

export const Progress = (props: IProgressProps) => {
  const { color, striped, label, ...linearProgressProps } = props
  return (
    <ProgressStyled color={color} striped={striped}>
      <LinearProgress
        {...linearProgressProps}
        classes={{ root: 'root', bar: 'bar' }}
        aria-label={label}
      />
    </ProgressStyled>
  )
}
